__turbopack_context__.v({
  "accent": "WithColorInBackgroundWrapper-module-scss-module__xIMXyW__accent",
  "accent-bright": "WithColorInBackgroundWrapper-module-scss-module__xIMXyW__accent-bright",
  "accent-dark": "WithColorInBackgroundWrapper-module-scss-module__xIMXyW__accent-dark",
  "accent-light": "WithColorInBackgroundWrapper-module-scss-module__xIMXyW__accent-light",
  "black": "WithColorInBackgroundWrapper-module-scss-module__xIMXyW__black",
  "bright": "WithColorInBackgroundWrapper-module-scss-module__xIMXyW__bright",
  "container": "WithColorInBackgroundWrapper-module-scss-module__xIMXyW__container",
  "gradient-accent": "WithColorInBackgroundWrapper-module-scss-module__xIMXyW__gradient-accent",
  "gray": "WithColorInBackgroundWrapper-module-scss-module__xIMXyW__gray",
  "gray-dark": "WithColorInBackgroundWrapper-module-scss-module__xIMXyW__gray-dark",
  "gray-light": "WithColorInBackgroundWrapper-module-scss-module__xIMXyW__gray-light",
  "gray-light2": "WithColorInBackgroundWrapper-module-scss-module__xIMXyW__gray-light2",
  "main": "WithColorInBackgroundWrapper-module-scss-module__xIMXyW__main",
  "main-dark": "WithColorInBackgroundWrapper-module-scss-module__xIMXyW__main-dark",
  "main-light": "WithColorInBackgroundWrapper-module-scss-module__xIMXyW__main-light",
  "root": "WithColorInBackgroundWrapper-module-scss-module__xIMXyW__root",
  "transparent": "WithColorInBackgroundWrapper-module-scss-module__xIMXyW__transparent",
  "white": "WithColorInBackgroundWrapper-module-scss-module__xIMXyW__white",
});
